'use strict';

let isMobile = require('.././utilities/clientSideUtil').isMobile;

module.exports = {
    loadImageCardImageBasedOnViewPort : function () {
        $(window).on('load', function () {
            var imageCardImages  =  $('.mbb-assets-image-card-js').find('.image-card-image-js');

            if (imageCardImages.length > 0) {
                imageCardImages.each(function () {
                    var $img = $(this);
                    
                    var focalX =  isMobile() && $img.data('focal-mobile-x') !== null ?  $img.data('focal-mobile-x') : $img.data('focal-desktop-x');
                    
                    var focalY =  isMobile() && $img.data('focal-mobile-y') !== null ? $img.data('focal-mobile-y') : $img.data('focal-desktop-y');

                    if (focalX.length > 0) {
                        $img.css("--focal-point-x", focalX);
                    }

                    if (focalY.length > 0) {
                        $img.css("--focal-point-y", focalY);
                    }
                });
            }
        })    
    }
};
